import { Outlet } from "react-router-dom";
import CookieBanner from "./CookieBanner";
import Footer from "./Footer";
import Header from "./Header";

export default function Layout() {
  return (
    <div className="site-shell">
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
